// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/form","groupRoot":"form-m__groupRoot__1GZh0","column":"form-m__column__RcZp-","fieldRoot":"form-m__fieldRoot__2hJGo"};